module.exports = __webpack_public_path__ + "static/media/35.141b8f98.png";